module.exports = __webpack_public_path__ + "img/info_dark_24dp.648e8c54.svg";